<i18n src="@/locales/components/CbsSelectMonthTranslate.json"></i18n>

<template>
	<el-select v-bind="$attrs" v-on="$listeners" class="cbs-select-month">
		<el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value" />
	</el-select>
</template>

<script>
export default {
	inheritAttrs: false,
	name: "CbsSelectMonth",
	data() {
		return {
			monthOptions: [
				{ label: this.$t("Jan"), value: 1 },
				{ label: this.$t("Feb"), value: 2 },
				{ label: this.$t("Mar"), value: 3 },
				{ label: this.$t("Apr"), value: 4 },
				{ label: this.$t("May"), value: 5 },
				{ label: this.$t("Jun"), value: 6 },
				{ label: this.$t("Jul"), value: 7 },
				{ label: this.$t("Aug"), value: 8 },
				{ label: this.$t("Sep"), value: 9 },
				{ label: this.$t("Oct"), value: 10 },
				{ label: this.$t("Nov"), value: 11 },
				{ label: this.$t("Dec"), value: 12 }
			]
		};
	}
};
</script>
